export interface ITypeList {
    ndd: boolean,
    sv: boolean,
    fv: boolean,
    bridge: boolean,
    dd: boolean,
    paired: boolean,
    remote: boolean
}